import { Component, OnInit, HostBinding } from '@angular/core';
import { PageComponent, PageService } from 'common';
import { GoogleCastService } from '../google-cast.service';

@Component({
    selector: 'tyt-cast-button',
    templateUrl: './cast-button.component.html',
    styleUrls: ['./cast-button.component.scss']
})
export class CastButtonComponent extends PageComponent {

    constructor(
        private pageService: PageService,
        private googleCastService: GoogleCastService
    ) {
        super(pageService);
    }

    @HostBinding('class.hidden')
    get isVisible() {
        return !this.available && !this.connected;
    }

    available: boolean = false;
    connected: boolean = false;
    connecting: boolean = false;

    async init() {
        let self = this;

        this.subscribe(this.googleCastService.availableChanged, state => this.available = state);
        this.subscribe(this.googleCastService.connectedChanged, state => self.connected = state);
        this.subscribe(this.googleCastService.connectingChanged, state => self.connecting = state);
    }

    async startCast() {
        this.googleCastService.castNow();
    }

    async stopCast() {
        this.googleCastService.stopCasting();
    }

}
